export default __webpack_public_path__ + "static/media/timer-presets.a81e51ae.svg";